<template>
	<div class="service-locations-sms-email-card">
		<!-- Appointment Section -->
		<SectionContainer>
			<template #left>
				<h4>Appointment</h4>
			</template>
			<template #content>
				<!-- RO Default Advisor -->
				<dl>
					<dd>
						Email Provider
					</dd>
					<dd>
						Reply-To Email
					</dd>
					<dd>
						SMS Provider
					</dd>
				</dl>
			</template>
		</SectionContainer>
		<!-- RO Section -->
		<SectionContainer>
			<template #left>
				<h4>Repair Order</h4>
			</template>
			<template #content>
				<dl>
					<dd>
						Email Provider
					</dd>
					<dd>
						Reply-To Email
					</dd>
					<dd>
						SMS Provider
					</dd>
				</dl>
			</template>
		</SectionContainer>
		<!-- RO Payment Section -->
		<SectionContainer>
			<template #left>
				<h4>Repair Order Payment</h4>
			</template>
			<template #content>
				<!-- RO Default Advisor -->
				<dl>
					<dd>
						Email Provider
					</dd>
					<dd>
						Reply-To Email
					</dd>
					<dd>
						SMS Provider
					</dd>
				</dl>
			</template>
		</SectionContainer>
	</div>
</template>

<script>
import SectionContainer from '@/components/shells/section-container/section-container';

export default {
	name: 'ServiceLocationsSmsEmailCard',
	components: { SectionContainer }
};
</script>

<style lang="scss" scoped>
.service-locations-sms-email-card {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 12px;

	&__item {
		display: block;
	}

	.section-header {
		display: inline-block;
	}
}
</style>
